/* ══ v14.3 (a): THE ACTIVITY VIEW ══════════════════════════════════════════════════════════
   Portfolio level only — his ruling, and it also honours the standing rule that the six
   PMBOK-aligned project areas are a closed set. The switch beside the title is the same control
   the portfolio already needed for this; project-level surfaces are untouched. */
let _pfPane = 'programmes';          /* 'programmes' | 'activity' | 'improvement' (v14.4 a) */
let _actShown = 100;                 /* ◆: Load more, ~100 a page */
let _actWho = 'all', _actType = 'all', _actProg = 'all', _actProj = 'all';
const ACT_PAGE = 100;
let _actPeriod = 'all', _actQuery = '', _actBatchSize = ACT_PAGE;
/* v14.4 (a): the Continuous improvement pane's filters — person · type · category ·
   programme · project. Entries ride the data parts already merged into __DB__, so unlike
   Activity this pane reads nothing from disk when it opens. */
let _ciWho = 'all', _ciTypeF = 'all', _ciCat = 'all', _ciProg = 'all', _ciProj = 'all';

function setPortfolioPane(pane) {
  _pfPane = (pane === 'activity') ? 'activity'
          : (pane === 'improvement') ? 'improvement' : 'programmes';
  if (_pfPane === 'programmes') _reorderUiBind('programme', '');
  else { _reorderUiReset(); _pfResetExpansion(); }
  if (_pfPane === 'activity') {
    _actShown = _actBatchSize;
    /* The ledger is never read at boot: nothing is fetched until this moment. */
    _loadAllLogs(true).then(renderPortfolio).catch(function (e) {
      console.warn('The activity log could not be read.', e);
      renderPortfolio();
    });
  }
  renderPortfolio();
}

/* ⚠ Split on UNDERSCORES and HYPHENS as well as spaces and dots. Found by looking at the
   rendered feed: a writer id is `gregor_porzel.c0y6`, so the person is `gregor_porzel`, and
   splitting on spaces alone made that ONE word - a single-letter avatar for every real account
   on this machine, since Windows usernames are underscore-separated. */
function _actInitials(name) {
  const p = String(name || '').trim().split(/[\s._-]+/).filter(Boolean);
  return p.length ? p.map(w => w[0]).join('').slice(0, 2).toUpperCase() : '—';
}
/* A writer id is `user.machine`; the person is the user half — the same reasoning as v14.1's
   roster, which counts PEOPLE rather than files. */
function _actPerson(writerId) {
  /* v18: a writer is a username; legacy `<user>.<machine>` ids still read as their user. */
  const s = String(writerId || '');
  const i = s.indexOf('.');
  const user = (i > 0 ? s.slice(0, i) : s);
  const known = (_srvUsersCache || []).find(u => u && u.username === user);
  return (known && known.displayName) || user || 'someone';
}
function _actIsMe(writerId) { return String(writerId || '') === _myWriterId(); }

function _actDayLabel(iso) {
  const d = new Date(iso);
  if (isNaN(d)) return '';
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const day = new Date(d); day.setHours(0, 0, 0, 0);
  const diff = Math.round((today - day) / 86400000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Yesterday';
  return '';
}
function _actDayKey(iso) {
  /* v15.2: the LOCAL date, not the ISO/UTC slice — the feed shows local times, and grouping
     by the UTC date filed a 00:30 CEST save under the previous day's header. */
  const d = new Date(iso);
  if (isNaN(d)) return String(iso || '').slice(0, 10);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')
       + '-' + String(d.getDate()).padStart(2, '0');
}
function _actTime(iso) {
  const d = new Date(iso);
  if (isNaN(d)) return '';
  return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
}

/* The four filters — person · change type · programme · project (◆: "change type", never
   "actions", which would collide with the Actions register). */
/* v15.1: a change row is PHANTOM when nothing about it survives translation — no field
   old→news and every named content key display-suppressed (the `_deletedIds` class: runtime
   bookkeeping the v14.4–v15 mint wrote on every save). The file keeps the entry byte-for-byte;
   the feed stops asserting a change nobody made. Legacy boolean `content: true` rows are NOT
   phantom — they may describe a real long-text edit, and there is no way to know otherwise. */
function _actChangeIsPhantom(c) {
  if (!c || c.verb !== 'changed') return false;
  if (Array.isArray(c.fields) && c.fields.length) return false;
  if (!Array.isArray(c.content) || !c.content.length) return false;
  return c.content.every(function (k) { return !_logFieldLabel(k); });
}
/* Search only display strings belonging to this change, never hidden log payloads. */
function _actSearchText(value) { return String(value == null ? '' : value).trim().replace(/\s+/g, ' ').toLowerCase(); }
function _actSearchTexts(e, c) {
  const texts = [_actPerson(e.w), _actIsMe(e.w) ? 'You' : '', c.verb || 'changed',
    LOG_KIND_LABEL[c.kind] || c.kind || 'record', c.ref, c.title, c.prog, c.proj];
  (Array.isArray(c.fields) ? c.fields : []).forEach(function (f) {
    const label = _logFieldLabel(f.f);
    if (label) texts.push(label, f.from == null ? '' : (f.from || '—'), f.to == null ? '' : (f.to || '—'));
  });
  (Array.isArray(c.content) ? c.content : []).forEach(function (key) {
    const label = _logFieldLabel(key); if (label) texts.push(label + ' changed');
  });
  if (c.content === true) texts.push('description changed');
  return texts.map(_actSearchText);
}
function _actFiltered() {
  const query = _actSearchText(_actQuery), now = Date.now();
  const days = _actPeriod === '30' ? 30 : _actPeriod === '90' ? 90 : 0;
  return _allLogEntries().filter(function (e) {
    if (_actWho !== 'all' && _actPerson(e.w) !== _actWho) return false;
    if (!days) return true;
    const at = new Date(e.at).getTime();
    return Number.isFinite(at) && at >= now - days * 86400000 && at <= now;
  }).map(function (e) {
    const changes = (e.changes || []).filter(function (c) {
      if (_actChangeIsPhantom(c)) return false;   /* v15.1 — before the count is taken */
      if (_actType !== 'all' && c.verb !== _actType) return false;
      if (_actProg !== 'all' && String(c.prog || '') !== _actProg) return false;
      if (_actProj !== 'all' && String(c.proj || '') !== _actProj) return false;
      return !query || _actSearchTexts(e, c).some(function (text) { return text.includes(query); });
    });
    return { w: e.w, at: e.at, changes: changes };
  }).filter(function (e) {
    if (!e.changes.length) return false;   /* a save whose every row was phantom shows nothing */
    if (_actWho !== 'all' && _actPerson(e.w) !== _actWho) return false;
    return true;
  });
}

function _actOptions() {
  /* v15.2: built from the DISPLAYABLE corpus — a writer whose every row is phantom
     (`_deletedIds`-only saves from v14.4–v15) was offered as a filter that could only ever
     produce "nothing matches", and the phantom rows' programmes/projects likewise. */
  const people = {}, progs = {}, projs = {};
  _allLogEntries().forEach(function (e) {
    let visible = false;
    (e.changes || []).forEach(function (c) {
      if (_actChangeIsPhantom(c)) return;
      visible = true;
      if (c.prog) progs[c.prog] = 1;
      if (c.proj) projs[c.proj] = 1;
    });
    if (visible) people[_actPerson(e.w)] = 1;
  });
  return { people: Object.keys(people).sort(), progs: Object.keys(progs).sort(),
           projs: Object.keys(projs).sort() };
}

function setActFilter(which, value) {
  if (which === 'who') _actWho = value;
  else if (which === 'type') _actType = value;
  else if (which === 'prog') _actProg = value;
  else if (which === 'proj') _actProj = value;
  else if (which === 'period') _actPeriod = ['all', '30', '90'].includes(value) ? value : 'all';
  else if (which === 'batch') _actBatchSize = ['50', '100', '250'].includes(String(value)) ? Number(value) : ACT_PAGE;
  _actShown = _actBatchSize;
  renderPortfolio();
}
function actShowMore() { _actShown = Math.min(_actShown + _actBatchSize, _actFiltered().length); renderPortfolio(); }
function actSearchInput(input, event) {
  if (!input.isConnected || _pfPane !== 'activity' || !document.body.classList.contains('view-portfolio')
      || input._actComposing || (event && event.isComposing)) return;
  _actQuery = input.value;
  _actShown = _actBatchSize;
  renderPortfolio();
}
function actSearchClear() {
  _actQuery = ''; _actShown = _actBatchSize;
  renderPortfolio();
  const input = document.getElementById('actSearch');
  if (input && _pfPane === 'activity' && document.body.classList.contains('view-portfolio')) input.focus({ preventScroll: true });
}

/* v14.4 (c): what a field is CALLED on a ledger line. Raw keys are stored in the file (a
   record, never rewritten); the reading side translates. Two keys may share a label
   (requester/requestor) — the renderer dedupes by label. */
const LOG_FIELD_LABEL = {
  due: 'due date', closedDate: 'closed date', requestor: 'requested by',
  requester: 'requested by', tz: 'timezone', startTime: 'start', endTime: 'end',
  flagged: 'on agenda', plannedStart: 'planned start', plannedFinish: 'planned finish',
  engagementCurrent: 'engagement (current)', engagementTarget: 'engagement (target)',
  level: 'RAG', rag: 'RAG', raisedBy: 'raised by',
  desc: 'description', what: 'description', statement: 'statement',
  description: 'description', details: 'details', notes: 'notes', response: 'response',
  rationale: 'rationale', measure: 'measure', updates: 'update notes',
  attendees: 'attendees', agenda: 'agenda', diff: 'update notes',
  better: "what we'd do differently",
  parentId: 'parent action', dependsOn: 'dependencies', relatedTo: 'related items',
  audienceIds: 'audience', audienceAll: 'audience', projectIds: 'linked projects',
  roleTypes: 'role types', noWbs: 'WBS exclusion',
  'dashboard.notes': 'project notes', 'dashboard.rag': 'overall status',
  /* v16.5 (b): the dotted leaf paths carry their own labels, because _logFieldLabel's fallback
     only strips ONE leading segment and would leave 'rag.level' / 'dashboard.rag.level' on screen. */
  'rag.level': 'RAG', 'appMeta.dashboard.rag.level': 'overall status',
  'appMeta.predecessorUids': 'project predecessors',
  'dashboard.scope': 'scope lists', 'dashboard.gates': 'gates',
  name: 'name', title: 'title'
};
function _logFieldLabel(k) {
  /* v15.1: a `_`-prefixed key is runtime bookkeeping, never a person's work — return '' and the
     renderer's own empty-label guard skips it. This is for entries ALREADY ON DISK: his log
     carries "content":["_deletedIds"] rows from every save v14.4–v15 made (the phantom fixed at
     the root in REV_PROJECT_SKIP). The file is history and stays byte-identical; the display
     simply stops repeating a name that never described anything anyone did. */
  if (String(k).charAt(0) === '_') return '';
  /* v15.3 (b): the same treatment for a meeting's derived `diff`, and for the same reason the
     `_deletedIds` rows got it — THIS IS FOR ENTRIES ALREADY ON DISK. His log carries
     `"content":["diff"]` rows minted by every v14.3–v15.2 save in which he touched an action;
     the file is history and stays byte-identical, and `_actChangeIsPhantom` drops a row whose
     every name is suppressed, so those rows simply stop asserting a change he never made.
     New saves never mint it at all — see `_logNoiseKey`. */
  if (k === 'diff') return '';
  if (Object.prototype.hasOwnProperty.call(LOG_FIELD_LABEL, k)) return LOG_FIELD_LABEL[k];
  return String(k).replace(/^appMeta\./, '').replace(/^dashboard\./, '');
}
function _actChangeHtml(c) {
  const verb = _escapeHtml(c.verb || 'changed');
  const kind = _escapeHtml(LOG_KIND_LABEL[c.kind] || c.kind || 'record');
  const ref = c.ref ? `<span class="act-ref">${_escapeHtml(c.ref)}</span>` : '';
  const title = c.title ? `<span class="act-title">${_escapeHtml(c.title)}</span>`
                        : `<span class="act-kind">(untitled)</span>`;
  /* ◆6: every row names its programme and project — dropped automatically once a filter has
     made it redundant, which is the second half of that ruling. */
  const bits = [];
  if (_actProg === 'all' && c.prog) bits.push(_escapeHtml(c.prog));
  if (_actProj === 'all' && c.proj) bits.push(_escapeHtml(c.proj));
  const ctx = bits.length ? `<span class="act-ctx">${bits.join(' · ')}</span>` : '';
  /* ◆5: old → new for short fields; content says only THAT it changed.
     v14.4 (c): content changes are NAMED — one "… changed" per touched field, translated
     through LOG_FIELD_LABEL and deduped by label. Entries v14.3 wrote carry a plain boolean
     and keep their old wording: the file is history, and history is not rewritten. */
  let fields = '';
  const fs = Array.isArray(c.fields) ? c.fields : [];
  const named = Array.isArray(c.content) ? c.content : [];
  if (fs.length || named.length || c.content === true) {
    const parts = fs.map(function (f) {
      return `<span class="act-kind">${_escapeHtml(_logFieldLabel(f.f))}</span> ` +
             `<span class="act-from">${_escapeHtml(f.from || '—')}</span> → ` +
             `<span>${_escapeHtml(f.to || '—')}</span>`;
    });
    const seenLbl = {};
    named.forEach(function (k) {
      const lbl = _logFieldLabel(k);
      if (!lbl || seenLbl[lbl]) return;
      seenLbl[lbl] = 1;
      parts.push(`<span class="act-kind">${_escapeHtml(lbl)} changed</span>`);
    });
    if (c.content === true) parts.push(`<span class="act-kind">description changed</span>`);
    fields = `<div class="act-fields">${parts.join(' · ')}</div>`;
  }
  return `<div class="act-row"><span class="act-verb ${verb}">${verb}</span>` +
         `<span class="act-kind">${kind}</span>${ref}${title}${ctx}${fields}</div>`;
}

function _activityHtml() {
  const broken = (_logRows || []).filter(function (r) { return r && r.error; });
  /* ⚠ Refused BY NAME, exactly as a damaged part is — the rest of the feed still shows. */
  const brokenHtml = broken.length
    ? `<div class="act-broken">⚠ ${broken.length} activity log${broken.length > 1 ? 's' : ''} could not be read and ${broken.length > 1 ? 'are' : 'is'} not shown here: ` +
      broken.map(function (r) { return _escapeHtml(r.file); }).join(', ') + `</div>`
    : '';

  const opts = _actOptions();
  const sel = function (id, which, cur, values, allLabel) {
    return `<select class="sort-select" id="${id}" onchange="setActFilter('${which}',this.value)">` +
      `<option value="all"${cur === 'all' ? ' selected' : ''}>${allLabel}</option>` +
      values.map(function (v) {
        return `<option value="${_escapeHtml(v)}"${cur === v ? ' selected' : ''}>${_escapeHtml(v)}</option>`;
      }).join('') + `</select>`;
  };
  /* ⚠ The change-type list needs LABELS, not the raw verbs: the dropdown showed a lowercase
     "deleted" beside four properly-cased controls. Found in the rendered view. */
  const selLabelled = function (id, which, cur, pairs, allLabel) {
    return `<select class="sort-select" id="${id}" onchange="setActFilter('${which}',this.value)">` +
      `<option value="all"${cur === 'all' ? ' selected' : ''}>${allLabel}</option>` +
      pairs.map(function (pr) {
        return `<option value="${pr[0]}"${cur === pr[0] ? ' selected' : ''}>${pr[1]}</option>`;
      }).join('') + `</select>`;
  };
  const bar = `<div class="act-bar">` +
    sel('actWho', 'who', _actWho, opts.people, 'Everyone') +
    selLabelled('actType', 'type', _actType,
      [['added', 'Added'], ['changed', 'Changed'], ['completed', 'Completed'],
       ['cancelled', 'Cancelled'], ['deleted', 'Deleted']], 'All change types') +
    sel('actProg', 'prog', _actProg, opts.progs, 'All programmes') +
    sel('actProj', 'proj', _actProj, opts.projs, 'All projects') +
    `<div class="act-control"><label for="actPeriod">Period</label>` +
    selLabelled('actPeriod', 'period', _actPeriod, [['30', 'Last 30 days'], ['90', 'Last 90 days']], 'All time') + `</div>` +
    `<div class="act-control act-search"><label for="actSearch">Search activity</label><div class="act-search-box">` +
    `<input id="actSearch" type="text" placeholder="Search activity…" value="${_escapeHtml(_actQuery)}" autocomplete="off">` +
    `<button type="button" onclick="actSearchClear()" aria-label="Clear activity search"${_actQuery ? '' : ' hidden'}>×</button></div></div>` +
    `<div class="act-control"><label for="actBatchSize">Saves per batch</label>` +
    `<select class="sort-select" id="actBatchSize" onchange="setActFilter('batch',this.value)">` +
    [50, 100, 250].map(function (n) { return `<option value="${n}"${_actBatchSize === n ? ' selected' : ''}>${n}</option>`; }).join('') +
    `</select></div></div>`;

  const all = _actFiltered();
  const countHtml = `<div class="act-count" role="status">Showing ${Math.min(_actShown, all.length)} of ${all.length} matching save${all.length === 1 ? '' : 's'}</div>`;
  if (!all.length) {
    /* v15.2: "any at all" counts entries that could ever DISPLAY — a log of pure phantom
       rows used to render "Nothing matches these filters — try widening them" with every
       control at "all": a wrong explanation for an honestly empty feed. */
    const anyAtAll = _allLogEntries().some(function (e) {
      return (e.changes || []).some(function (c) { return !_actChangeIsPhantom(c); });
    });
    return bar + brokenHtml + countHtml + `<div class="act-empty">` +
      (anyAtAll
        ? `<b>Nothing matches these filters</b>Try widening the filters or clearing the search — everything is still recorded.`
        : `<b>Nothing recorded yet</b>Changes are written down from the moment this version is installed.<br>Everyone's saves appear here, newest first.`) +
      `</div>`;
  }

  const page = all.slice(0, _actShown);
  let html = bar + brokenHtml + countHtml, lastDay = null;
  page.forEach(function (e) {
    const key = _actDayKey(e.at);
    if (key !== lastDay) {
      lastDay = key;
      const rel = _actDayLabel(e.at);
      html += `<div class="act-day"><b>${rel || _escapeHtml(formatDateDisplay(key))}</b>` +
              (rel ? `<span>${_escapeHtml(formatDateDisplay(key))}</span>` : '') + `</div>`;
    }
    const person = _actPerson(e.w);
    const mine = _actIsMe(e.w);
    const n = e.changes.length;
    /* ◆4: ONE ROW PER SAVE, with that save's changes nested beneath it. */
    html += `<div class="act-save"><div class="act-head">` +
      `<span class="act-av${mine ? ' me' : ''}">${_escapeHtml(_actInitials(person))}</span>` +
      `<span class="act-who"><b>${mine ? 'You' : _escapeHtml(person)}</b> ` +
      `saved ${n} change${n === 1 ? '' : 's'}</span>` +
      `<span class="act-when">${_escapeHtml(_actTime(e.at))}</span></div>` +
      `<div class="act-changes">${e.changes.map(_actChangeHtml).join('')}</div></div>`;
  });
  if (all.length > page.length) {
    html += `<button class="act-more" onclick="actShowMore()">Load more — ${all.length - page.length} older save${all.length - page.length === 1 ? '' : 's'}</button>`;
  }
  return html;
}

